// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-wrapper[data-v-6dbb258a]{display:flex;justify-content:center}.loader[data-v-6dbb258a]{position:relative;width:6rem;height:6rem}.num[data-v-6dbb258a]{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
